import React, { useState } from "react";
import { TIPOGRAFIAS, CATEGORIAS } from "../../data/tipografias-studio";

/**
 * FontSelector
 * Category filters + 2-column grid of font previews.
 * The preview text uses the user's current `text` (trimmed to 12 chars) or
 * falls back to each font's `preview` token.
 */
const FontSelector = ({ selected, onChange, text }) => {
  const [cat, setCat] = useState("todas");

  const filtered = TIPOGRAFIAS.filter(
    (f) => cat === "todas" || f.categoria === cat
  );

  const getPreview = (t) =>
    text && text.trim() ? text.trim().slice(0, 12) : t.preview;

  return (
    <div data-testid="studio-font-selector">
      {/* ── Category filters ── */}
      <div style={{ display: "flex", flexWrap: "wrap", gap: 4, marginBottom: 10 }}>
        {CATEGORIAS.map((c) => {
          const active = cat === c.id;
          return (
            <button
              key={c.id}
              onClick={() => setCat(c.id)}
              data-testid={`studio-font-cat-${c.id}`}
              style={{
                background: active ? "rgba(0,212,255,.1)" : "transparent",
                border: `1px solid ${active ? "#00d4ff" : "rgba(255,255,255,.1)"}`,
                color: active ? "#00d4ff" : "rgba(255,255,255,.35)",
                padding: "3px 9px",
                fontFamily: "'Courier New', monospace",
                fontSize: ".52rem",
                letterSpacing: ".12em",
                borderRadius: 4,
                cursor: "pointer",
                transition: "all .15s",
              }}
            >
              {c.label}
            </button>
          );
        })}
      </div>

      {/* ── Font grid ── */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 6,
          maxHeight: 280,
          overflowY: "auto",
          paddingRight: 2,
        }}
      >
        {filtered.map((font) => {
          const active = selected === font.familia;
          const previewSize =
            font.categoria === "script"
              ? "1.1rem"
              : font.id === "press"
              ? ".55rem"
              : font.id === "sacramento" || font.id === "greatvibes"
              ? "1.2rem"
              : ".9rem";
          return (
            <button
              key={font.id}
              onClick={() => onChange(font.familia)}
              data-testid={`studio-font-${font.id}`}
              style={{
                background: active ? "rgba(0,212,255,.08)" : "rgba(255,255,255,.02)",
                border: `1px solid ${active ? "#00d4ff" : "rgba(255,255,255,.08)"}`,
                borderRadius: 6,
                padding: "8px 10px",
                cursor: "pointer",
                textAlign: "left",
                transition: "all .15s",
                display: "flex",
                flexDirection: "column",
                gap: 4,
                minWidth: 0,
              }}
              onMouseEnter={(e) => {
                if (!active)
                  e.currentTarget.style.borderColor = "rgba(255,255,255,.2)";
              }}
              onMouseLeave={(e) => {
                if (!active)
                  e.currentTarget.style.borderColor = "rgba(255,255,255,.08)";
              }}
            >
              <span
                style={{
                  fontFamily: `"${font.familia}", sans-serif`,
                  fontSize: previewSize,
                  color: active ? "#00d4ff" : "#f0f4ff",
                  lineHeight: 1.2,
                  display: "block",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {getPreview(font)}
              </span>
              <span
                style={{
                  fontFamily: "'Courier New', monospace",
                  fontSize: ".5rem",
                  letterSpacing: ".08em",
                  color: "rgba(255,255,255,.3)",
                  display: "block",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {font.nombre}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default FontSelector;
